import { render, staticRenderFns } from "./ListaEscolas.vue?vue&type=template&id=6b6c0722"
import script from "./ListaEscolas.vue?vue&type=script&lang=js"
export * from "./ListaEscolas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports